import { SimpleGuard } from 'interfaces/guards'
import { GetCCPaymentsAction } from 'components/features/creditCard/creditCardStore/actions'

export const ccPaymentsGuard: SimpleGuard = {
  name: `Credit Card Payment Guard`,
  checker: (state) => {
    return state.data.creditCard.payments !== null
  },
  loader: (dispatch) => {
    dispatch(new GetCCPaymentsAction())
  },
}
